import { Component, Input, SimpleChanges } from '@angular/core';
import { FileAction, FileData } from '@components/anexos/file/file.component';

export interface AnexosOptions {
  hideUpload?: boolean;
  hideSent?: boolean;
  disableUpload?: boolean;
  disableDelete?: boolean;
}

@Component({
  selector: 'app-anexos',
  templateUrl: './anexos.component.html',
  styleUrls: ['./anexos.component.scss'],
})
export class AnexosComponent {
  @Input()
  public title: string = '';

  @Input()
  public sentFiles: FileData[] = [];

  @Input()
  public options: AnexosOptions = {
    hideUpload: false,
    hideSent: false,
    disableDelete: true,
  };

  public files: FileData[] = [];

  public deletedFiles: FileData[] = [];

  protected fileActions: FileAction[] = [
    {
      icon: 'download',
      label: 'Download',
      action: this.downloadFile.bind(this),
    },
    {
      icon: 'delete',
      label: 'Remover',
      action: this.removeFile.bind(this),
    },
  ];

  protected fileSentActions: FileAction[] = [
    {
      icon: 'download',
      label: 'Download',
      action: this.downloadFile.bind(this),
    },
    {
      icon: 'delete',
      label: 'Excluir',
      action: this.deleteFile.bind(this),
      disabled: true,
    }
  ];

  protected readonly acceptedFiles = [
    'image/*',
    'application/pdf',
    'text/plain',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/xml',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ];
  
  constructor() {}

  public ngOnChanges(changes: SimpleChanges) {
    if (changes['options'] && changes['options'].currentValue.hasOwnProperty('disableDelete')) {
      this.fileSentActions[1].disabled = this.options.disableDelete;
    }
  }

  public setFiles(files: FileData[]) {
    this.files = files;
  }

  public setSentFiles(files: FileData[]) {
    this.sentFiles = files;
  }

  protected drop(event: any) {
    event.target.value = null;
    event.target.classList.remove('dragging');
  }

  protected dragover(event: any) {
    event.target.classList.add('dragging');
  }

  protected dragleave(event: any) {
    event.target.classList.remove('dragging');
  }

  protected loadFiles(event: any) {
    const files = Array.from<File>(event.target.files);

    for (const file of files) {
      const isTypeValid = this.checkFileType(file.type);
      
      if (!isTypeValid) {
        event.target.classList.add('error');
        continue;
      }

      event.target.classList.remove('error');

      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {
        this.files.push({
          nomeArquivo: file.name.replace(/[\u0300-\u036f]/g, ""),
          base64: reader.result?.toString() || '',
        });
      };
    }
  }

  private removeFile(file: FileData) {
    this.files = this.files.filter((f) => f !== file);
  }

  private deleteFile(file: FileData) {
    if(file.id) {
      this.deletedFiles.push(file);
      this.sentFiles = this.sentFiles.filter((f) => f !== file);
    }
  }

  private downloadFile(file: FileData) {
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', file.base64);
    link.setAttribute('download', file.nomeArquivo);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  private checkFileType(type: string) {
    for (const acceptedFile of this.acceptedFiles) {
      if (acceptedFile.includes('*')) {
        const fileType = acceptedFile.split('/')[0];

        if (type.includes(fileType)) {
          return true;
        }
      } else if (type === acceptedFile) {
        return true;
      }
    }

    return false;
  }
}
